import { keepPreviousData } from "@tanstack/react-query";

import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchQuoteRequests } from "#modules/quoteRequests/infra/fetchQuoteRequests.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";
import { QuoteRequestStatusType } from "shared";

export const quoteRequestsQuery = (
  page = 1,
  filters?: {
    status?: QuoteRequestStatusType | undefined;
    ownerId?: string | undefined;
    isFavorite?: boolean | undefined;
  },
) => ({
  queryKey: queryKeys.quoteRequests.list(page, filters),
  queryFn: () => fetchQuoteRequests(page, filters),
  placeholderData: keepPreviousData,
  staleTime: STALE_TIME,
});
